import { toast } from "react-toastify";

const FIELD_LABELS = {
  phone: "Phone",
  email: "Email",
  first_name: "First name",
  last_name: "Last name",
  password1: "Password",
  password2: "Confirm password",
  zone: "Zone",
  center_type: "Center type",
  collection_center: "Collection center",
  non_field_errors: "",
  detail: ""
};

const labelFor = key => {
  if (FIELD_LABELS[key] !== undefined) return FIELD_LABELS[key];
  return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
};

const flattenErrors = (data, prefix = "") => {
  if (!data) return [];
  if (typeof data === "string") return [data];
  if (typeof data.detail === "string") return [data.detail];
  if (Array.isArray(data)) {
    return data.flatMap(item =>
      typeof item === "string" ? [item] : flattenErrors(item, prefix)
    );
  }
  if (typeof data !== "object") return [];

  const messages = Object.entries(data).flatMap(([key, value]) => {
    const label = labelFor(prefix ? `${prefix}.${key}` : key);
    if (typeof value === "string") {
      return label ? [`${label}: ${value}`] : [value];
    }
    if (Array.isArray(value)) {
      return value.flatMap(v => {
        if (typeof v === "string") return label ? [`${label}: ${v}`] : [v];
        return flattenErrors(v, label || key);
      });
    }
    return flattenErrors(value, label || key);
  });
  return messages.flat(Infinity).filter(Boolean);
};

export const formatApiError = (error, fallback = "Request failed") => {
  const data = error?.response?.data ?? error?.data;
  if (!data && error?.message) return error.message;
  if (!data) return fallback;
  const parts = flattenErrors(data);
  if (!parts.length) return fallback;
  return parts.join(" · ");
};

export const toastApiError = (error, fallback = "Request failed") => {
  const message = formatApiError(error, fallback);
  toast.error(message, { autoClose: 10000 });
};
